<i class="fas fa-grip-lines" title="Click and hold to drag the window"></i>
<i class="fas fa-grip-lines" title="Click and hold to drag the window"></i>
